import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addTour, fetchTours } from "../slices/tourSlice";
import { fetchFeatures } from "../slices/featuresSlice";
import "../Static Files/styles/Manage Tours/managetours.css";
import { fetchCategories } from "../slices/categorySlice";

const TourModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { features } = useSelector((state) => state.features);
  const { userInfo } = useSelector((state) => state.users);
  const { categories } = useSelector((state) => state.categories);
  const [imagePreview, setImagePreview] = useState(null);
  const [hotelAddCounter, setHotelAddCounter] = useState(1);
  const [hotelFormData, setHotelFormData] = useState({
    name: "",
    price: 0,
    tourId: 0,
  });
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    headerImageFile: "",
    slug: "",
    price: "",
    hasDiscount: false,
    discountPrice: 0,
    duration: "",
    includedFeatureIds: [],
    excludedFeatureIds: [],
    categoryId: "",
    language: "",
    country: "",
    departure: "",
    arrival: "",
    isPrivate: false,
    currency: "",
    phonenumber: "",
    isMultipleTour: false,
    countries: "",
    isSpecialOffer: false,
    specialOfferDescription: "",
    startDate: "",
    endDate: "",
    userEmail: "",
  });

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchFeatures()); // Fetch features when modal is opened
      dispatch(fetchCategories());
    }
  }, [isOpen, dispatch]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFeatureChange = (e, type) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedFeatures = checked
        ? [
            ...new Set([
              ...prev[
                type === "included"
                  ? "includedFeatureIds"
                  : "excludedFeatureIds"
              ],
              parseInt(value),
            ]),
          ]
        : prev[
            type === "included" ? "includedFeatureIds" : "excludedFeatureIds"
          ].filter((id) => id !== parseInt(value));

      return {
        ...prev,
        [type === "included" ? "includedFeatureIds" : "excludedFeatureIds"]:
          updatedFeatures,
      };
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, headerImageFile: file }));
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    // FormData'ya tüm alanları ekleyin
    form.append("title", formData.title);
    form.append("description", formData.description);
    form.append("slug", formData.slug);
    form.append("price", formData.price);
    form.append("hasDiscount", formData.hasDiscount);
    form.append("discountPrice", formData.discountPrice);
    form.append("duration", formData.duration);
    form.append("language", formData.language);
    form.append("departure", formData.departure);
    form.append("arrival", formData.arrival);
    form.append("isPrivate", formData.isPrivate);
    form.append("currency", formData.currency);
    form.append("phonenumber", formData.phonenumber);
    form.append("isSpecialOffer", formData.isSpecialOffer);
    form.append("specialOfferDescription", formData.specialOfferDescription);
    form.append("isMultipleTour", formData.isMultipleTour);
    form.append("country", formData.country);
    form.append("countries", formData.countries);
    form.append("categoryId", formData.categoryId);
    form.append("startDate", formData.startDate);
    form.append("endDate", formData.endDate);
    form.append("userEmail", userInfo?.email);

    // Features verilerini ekleyin
    formData.includedFeatureIds.forEach((id) => {
      form.append("includedFeatureIds", id);
    });

    // excludedFeatureIds array-i üçün
    formData.excludedFeatureIds.forEach((id) => {
      form.append("excludedFeatureIds", id);
    });

    // Header image dosyasını ekleyin
    if (formData.headerImageFile) {
      form.append("headerImageFile", formData.headerImageFile);
    } else {
      alert("Başlık resmi gereklidir.");
      return;
    }

    // API çağrısı
    const response = await dispatch(addTour(form));
    console.log(response);

    // Modalı kapat
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content  add-modal-for-tour">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>Yeni Tur Yarat</h2>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "10vw",
              marginLeft: "1vw",
            }}
          >
            <input
              type="checkbox"
              name="isPrivate"
              checked={formData.isPrivate}
              onChange={handleChange}
            />
            <label style={{ textWrap: "nowrap" }}>Şəxsi tur</label>
          </div>
          <input
            type="text"
            name="phonenumber"
            placeholder="Əməkdaşın əlaqə nömrəsi"
            value={formData.phonenumber}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="title"
            placeholder="Başlıq"
            value={formData.title}
            onChange={handleChange}
            required
          />
          <label>Başlıq Şəkli</label>
          <input
            type="file"
            name="headerImageFile"
            accept="image/*"
            onChange={handleImageChange}
          />
          {imagePreview && (
            <img src={imagePreview} alt="Preview" className="image-preview" />
          )}
          <textarea
            name="description"
            placeholder="Təsvir"
            value={formData.description}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="slug"
            placeholder="Slug"
            value={formData.slug}
            onChange={handleChange}
            required
          />
          <select
            className="combobox" 
            name="currency"
            value={formData.currency}
            onChange={(e) =>
              setFormData({ ...formData, currency: e.target.value })
            }
          >
            <option value="">Valyuta seçin</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="AZN">AZN</option>
          </select>

          <input
            type="number"
            name="price"
            placeholder="Qiymət"
            value={formData.price}
            onChange={(e) =>
              setFormData({ ...formData, price: parseInt(e.target.value) || 0 })
            }
            required
          />

          <input
            type="text"
            name="duration"
            placeholder="Müddət"
            value={formData.duration}
            onChange={handleChange}
          />
          <div className="features-section">
            <div
              className="add-features"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <h4>Əlavə olunan Xüsusiyyətlər</h4>
              <ul>
                {features.map((feature) => (
                  <li key={feature.id}>
                    <input
                      type="checkbox"
                      value={feature.id}
                      onChange={(e) => handleFeatureChange(e, "included")}
                    />
                    <label>{feature.name}</label>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className="add-features"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <h4>Çıxarılan Xüsusiyyətlər</h4>
              <ul>
                {features.map((feature) => (
                  <li key={feature.id}>
                    <input
                      type="checkbox"
                      value={feature.id}
                      onChange={(e) => handleFeatureChange(e, "excluded")}
                    />
                    <label>{feature.name}</label>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <input
            type="text"
            name="language"
            placeholder="Dil"
            value={formData.language}
            onChange={handleChange}
          />
          <input
            type="text"
            name="departure"
            placeholder="Yola Çıxış"
            value={formData.departure}
            onChange={handleChange}
          />
          <input
            type="text"
            name="arrival"
            placeholder="Varış"
            value={formData.arrival}
            onChange={handleChange}
          />
          <input
            type="checkbox"
            name="isSpecialOffer"
            checked={formData.isSpecialOffer}
            onChange={handleChange}
          />
          <label>Xüsusi təklif var?</label>
          {formData.isSpecialOffer && (
            <textarea
              name="specialOfferDescription"
              placeholder="Xüsusi Təklif Təsviri"
              value={formData.specialOfferDescription}
              onChange={handleChange}
            />
          )}

          <input
            type="checkbox"
            name="isMultipleTour"
            checked={formData.isMultipleTour}
            onChange={handleChange}
          />
          <label>Multiple turdur ?</label>
          {!formData.isMultipleTour && (
            <input
              type="text"
              name="country"
              placeholder="Olke"
              value={formData.country}
              onChange={handleChange}
            />
          )}
          {formData.isMultipleTour && (
            <input
              type="text"
              name="countries"
              placeholder="Gedilecek olkeler vergulle yazin"
              value={formData.countries}
              onChange={handleChange}
            />
          )}

          <select
            className="combobox"
            value={formData.categoryId} // Seçilən dəyəri göstərmək üçün
            onChange={(e) =>
              setFormData({ ...formData, categoryId: e.target.value })
            }
          >
            <option value="">Kateqoriya seçin</option> {/* Default boş seçim */}
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
          <label>Baslangic tarixi</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={(e) =>
              setFormData({ ...formData, startDate: e.target.value })
            }
          />

          <label>Geri donus tarixi</label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={(e) =>
              setFormData({ ...formData, endDate: e.target.value })
            }
          />

          <button type="submit" className="submit-btn">
            Yarat
          </button>
        </form>
      </div>
    </div>
  );
};

export default TourModal;
